import React from "react";

export default function Community() {
  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#0F1117", color: "#FFFFFF", padding: "40px 24px", fontFamily: "sans-serif" }}>
      <div style={{ maxWidth: "680px", margin: "0 auto" }}>
        <h1 style={{ color: "#FF5B37", fontSize: "28px", marginBottom: "24px" }}>Sparkd Community Guidelines</h1>

        <div style={{ lineHeight: "1.6", color: "#9CA3AF", fontSize: "15px" }}>
          <h2 style={{ color: "#FFFFFF", fontSize: "18px", marginTop: "20px" }}>1. Real &amp; Authentic Connections</h2>
          <p>Sparkd is built on authentic identity and video verification. Impersonation, catfishing, or using misleading media is strictly prohibited.</p>

          <h2 style={{ color: "#FFFFFF", fontSize: "18px", marginTop: "20px" }}>2. Respect &amp; Safety First</h2>
          <p>Harassment, hate speech, bullying, solicitation, and unsolicited explicit content are grounds for immediate account termination.</p>

          <h2 style={{ color: "#FFFFFF", fontSize: "18px", marginTop: "20px" }}>3. Boundary &amp; Date Etiquette</h2>
          <p>Respect personal boundaries during 15-second vibe checks and virtual calls. Unconsented recording or screen-capturing of another member's video is strictly forbidden.</p>

          <h2 style={{ color: "#FFFFFF", fontSize: "18px", marginTop: "20px" }}>4. Incident Reporting</h2>
          <p>To report violations or seek support, contact our safety team directly at <a href="mailto:support@sparkd-app.com" style={{ color: "#FF5B37" }}>support@sparkd-app.com</a>.</p>
        </div>

        <div style={{ marginTop: "40px", paddingTop: "20px", borderTop: "1px solid #252836", fontSize: "12px", color: "#6B7280" }}>
          © Sparkd LLC. All rights reserved.
        </div>
      </div>
    </div>
  );
}
